import { renderLoginComponent } from "../components/Login";
import { navratNaHlavniStrankuPublic, showLogoffDialog } from "../utils/common.mjs";

function fetchUser() {

    fetch('/uzivatel')
    .then(response => response.json())
    .then((data) => {

        console.log("fetch user: " + data);

        let portalheaderbutton = document.getElementById('portalheaderbutton');
        portalheaderbutton.innerHTML = '';
        let nameChip = document.createElement('gov-chip');
        nameChip.setAttribute('variant', 'primary');
        nameChip.setAttribute('inverse', 'true');
        nameChip.setAttribute('tag', 'span');
        nameChip.setAttribute('size', 'm');
        nameChip.setAttribute('wcag-label', 'Jméno a příjmení přihlášeného');
        nameChip.innerText = data.jmeno + ' ' + data.prijmeni;
        portalheaderbutton.appendChild(nameChip);

        let logoffButton = document.createElement('gov-button');
        logoffButton.setAttribute('wcag-label', 'Tlačítko odhlášení z portálu');
        logoffButton.setAttribute('variant', 'primary');
        logoffButton.setAttribute('type', 'solid');
        logoffButton.setAttribute('inverse', 'true');
        logoffButton.setAttribute('size', 'm');
        logoffButton.setAttribute('href', "");
        logoffButton.setAttribute('native-type', 'button');
        logoffButton.innerText = 'Odhlásit se';
        logoffButton.addEventListener('gov-click', () => {
            showLogoffDialog();});

        let logoffIcon = document.createElement('gov-icon');
        logoffIcon.setAttribute('type', 'basic');
        logoffIcon.setAttribute('name', 'box-arrow-in-right');
        logoffIcon.setAttribute('slot', 'right-icon');

        logoffButton.appendChild(logoffIcon);
        portalheaderbutton.appendChild(logoffButton);
    });
}

function initHeader(isPublic) {
    const portalHeadline = document.getElementById("portal-headline");
    portalHeadline.onclick = navratNaHlavniStrankuPublic;

    if (!isPublic) {
        fetchUser();
    } else {
        const userInfoButton = document.getElementById('user-info-button');
        userInfoButton.addEventListener("gov-click", (event) => renderLoginComponent(null, event));
    }
}

export { initHeader };